import { queryOptions } from "@tanstack/react-query";
import type { getUserByOwnerIdForm, getUserForm } from "../dtos/request/user.request";
import { getUserByOwnerId, getUserDetail, getUserList } from "../v1/user.service";

export const useUserList = (form: getUserForm, enabled: boolean = true) =>
  queryOptions({
    queryKey: ["user-list", form.page, form.role, form.size],
    queryFn: () => getUserList(form),
    enabled,
    retry: 1,
  });

export const useUserDetail = (id: string) =>
  queryOptions({
    queryKey: ["user-detail", id],
    queryFn: () => getUserDetail(id),
    enabled: !!id,
    retry: 1,
  });

export const useUserByOwnerId = (form: getUserByOwnerIdForm) =>
  queryOptions({
    queryKey: ["user-by-owner-id", form.ownerId],
    queryFn: () => getUserByOwnerId(form),
    enabled: !!form.ownerId,
    retry: 1,
  });